import { Flex, Form, Select, Typography } from 'antd';
import { Rule } from 'antd/es/form';
import { FunctionComponent } from 'react';

interface SelectElementProps {
	label: string;
	name?: any;
	rules?: Rule[];
	options: { label: string; value: string | number | boolean; meta?: any }[];
	defaultValue?: string | number | boolean;
	onChange?(value: string | number | boolean, meta?: any): void;
	style?: React.CSSProperties;
	isLoading?: boolean;
	fullWidth?: boolean;
	disabled?: boolean;
}

const SelectElement: FunctionComponent<SelectElementProps> = ({
	label,
	name,
	rules,
	options,
	defaultValue,
	onChange,
	isLoading,
	fullWidth,
	disabled,
	style = { width: 'var(--inputWidth)', maxWidth: '100%' },
}) => {
	const handleChange = (value: string | number | boolean, option: any) => {
		if (onChange) {
			onChange(value, option?.meta);
		}
	};

	return (
		<Flex vertical>
			<Typography.Text style={{ marginBottom: 5, fontSize: 15 }}>{label}</Typography.Text>
			{name ? (
				<Form.Item name={name} style={{ maxWidth: fullWidth ? 'unset' : 'var(--inputWidth)', marginBottom: 0 }} rules={rules}>
					<Select style={fullWidth ? { width: '100%' } : {...style}} options={options} loading={isLoading} defaultValue={defaultValue} disabled={disabled} onChange={handleChange} />
				</Form.Item>
			) : (
				<Select style={fullWidth ? { width: '100%' } : {...style}} options={options} loading={isLoading} defaultValue={defaultValue} onChange={handleChange} disabled={disabled} />
			)}
		</Flex>
	);
};

export default SelectElement;
